/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Misfit_2Inputs */

const en_pc_alt_misfit_2 = /** @type {(inputs: Pc_Alt_Misfit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converting Office files to PDF, or exporting to Word with the layout intact.`)
};

const zh_pc_alt_misfit_2 = /** @type {(inputs: Pc_Alt_Misfit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把 Office 文件转换为 PDF，或在保留版式的前提下导出为 Word。`)
};

/**
* | output |
* | --- |
* | "Converting Office files to PDF, or exporting to Word with the layout intact." |
*
* @param {Pc_Alt_Misfit_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_misfit_2 = /** @type {((inputs?: Pc_Alt_Misfit_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Misfit_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_misfit_2(inputs)
	return zh_pc_alt_misfit_2(inputs)
});
export { pc_alt_misfit_2 as "pc.alt.misfit.2" }